export const PackageNames = {
    Npm:"npm",
    Pipy:"pipy",
    Maven:"maven",
    Nuget:"nuget",
    Installer:"installer"
} as const